<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  <button
    *ngPermissions="permissionService.Permission.area_create"
    type="button"
    sb-button-primary
    [color]="'green'"
    [icon]="'plus'"
    [loading]="loading()"
    [iconButton]="true"
    [queryParams]="{returnTo: this.util.getPageLink()}"
    [sbRouterLink]="util.RoutingID.areaCreate"
    sbTooltip="{{ 'lang.areas.createArea' | translate }}"
  >
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

  <button
    *ngPermissions="permissionService.Permission.area_category_list"
    type="button"
    sb-button-primary
    [color]="'blue'"
    [icon]="'locationWorld'"
    [loading]="loading()"
    [iconButton]="true"
    [sbRouterLink]="util.RoutingID.areaCategories"
    sbTooltip="{{ 'lang.areas.manageCategories' | translate }}"
  >
  </button>

</ng-container>

<!------------------------------

    Table Wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'lang.headlines.areas' | translate}}"
  [isInModalContext]="isInModalContext"
  [itemsData]="areas()"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'areas'">

  <!------------------------------

      Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      #FilterPanelRef
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
      filterID="search"
    >

      <sb-filter-section
        title="{{'lang.globals.filterAttributes' |translate}}" icon="toggleOn"
        classes="tw-flex tw-flex-col tw-gap-2">
        <sb-filter-threeway-toggle filterID="isGlobal" [default]="null"
                                   [label]="'lang.attributeToggles.area.isGlobal' | translate"></sb-filter-threeway-toggle>
        <sb-filter-threeway-toggle filterID="hasCompany" [default]="null"
                                   [label]="'lang.attributeToggles.area.hasCompany' | translate"></sb-filter-threeway-toggle>
        <sb-filter-threeway-toggle filterID="hasCategory" [default]="null"
                                   [label]="'lang.attributeToggles.area.hasCategory' | translate"></sb-filter-threeway-toggle>
      </sb-filter-section>

      <sb-filter-section *ngPermissions="permissionService.Permission.company_list" title="{{'lang.globals.companies' | translate}}"
                         icon="company">
        <sb-filter-dto-list-select filterID="companies" [isSingleSelect]="true" [endpoint]="api.shared_Company_retrieveAll.bind(api)">
        </sb-filter-dto-list-select>
      </sb-filter-section>

      <sb-filter-section *ngPermissions="permissionService.Permission.area_category_list"
                         title="{{'lang.globals.areaCategories' | translate}}"
                         icon="locationWorld">
        <sb-filter-dto-list-select filterID="areaCategories" [endpoint]="api.ca_md_AreaCategory_retrieveAll.bind(api)">
        </sb-filter-dto-list-select>
      </sb-filter-section>

    </sb-filter-panel>
  </div>

  <!------------------------------

      Table Header

------------------------------->
  <ng-template #thead>
    <tr>
      <th>
        #
      </th>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        {{ 'lang.areas.address' | translate }}
      </th>
      <th>
        {{ 'lang.globals.category' | translate }}
      </th>
      <th>
        {{ 'lang.globals.company' | translate }}
      </th>
      <th>
        {{ 'lang.globals.modifiedAt' | translate }}
      </th>
      <th class="sticky-col last-col">
        @if (!isInModalContext) {
          {{ 'lang.globals.action' | translate }}
        } @else {
          <sb-comp-table-multi-select-button [selectionState]="selectionState()"
                                             (action)="selectAction($event)"></sb-comp-table-multi-select-button>
        }
      </th>
    </tr>
  </ng-template>

  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-area>
    @let isSelected = this.selectedAreas().has(area.id);
    <tr [ngClass]="{'selected': isSelected}">
      <td>
        {{ area.id }}
      </td>
      <td>
        <sb-comp-name-wrapper>
          @if (area.polygons && area.polygons.length > 0) {
            <a [sbMapTooltip]="{type: 'Polygon', data: util.geo.polygonDTOArrayToPolygonArray(area.polygons)}" class="link" container="body"
               firstLine
               ngbTooltip openDelay="300" placement="right left"
               tooltipClass="widthFix">
              <sb-icon class="mr-2" icon="location"></sb-icon>
              <sb-value-definition
                [text]="(area.name) || area.name === '' ? area.name : 'n. def.'">
              </sb-value-definition>
            </a>
          } @else {
            <span firstLine>
            <sb-value-definition
              [text]="(area.name) || area.name === '' ? area.name : 'n. def.'">
            </sb-value-definition>
          </span>
          }
          <sb-tags *ngPermissions="[permissionService.Permission.tag_list]" [dtoId]="area.id" [dtoType]="tagService.TaggableDTO.Area"
                   [tags]="area.tags" secondLine></sb-tags>
        </sb-comp-name-wrapper>
      </td>
      <td>
        @if (area?.address?.position) {
          <a
            [sbMapTooltip]="{type: 'Coordinates', data: { x: area.address.position.coordinates[0], y: area.address.position.coordinates[1] }}"
            class="link"
            container="body"
            ngbTooltip openDelay="300" placement="right left" tooltipClass="widthFix">
            <sb-icon class="mr-2" icon="location"></sb-icon>
            {{ stringTransformation.addressToString(area.address) }}
          </a>
        } @else {
          <span> {{ stringTransformation.addressToString(area.address) }}</span>
        }
      </td>
      <td>
        {{ area.category?.name }}
      </td>
      <td>
        {{ area.company?.name }}
      </td>
      <td>
        <sb-comp-display-modified [data]="area"></sb-comp-display-modified>
      </td>
      <td class="sticky-col last-col" nowrap>
        @if (!isInModalContext) {
          @if (!area.global) {
            <sb-split-button
              [splitButtonItems]="area.sbButtons ?? []"
            ></sb-split-button>
          }
        } @else {
          <sb-comp-table-select-button [isSelected]="isSelected" (action)="selectItem(area)"></sb-comp-table-select-button>
        }
      </td>
    </tr>
  </ng-template>

  <!---------------------------------------

  Card element

  ----------------------------------->

  <!-- no card element -->
  <div footer-more>
    @if (isInModalContext) {
      <div class="row">
        <div class="col-8">
          <div class="row" style="height: 100%; display: flex; align-items: center;">
            <div *ngFor="let e of selectedAreas().values()" class="col-3">
              <a [innerHTML]="e.name | truncate : 25" class="font-weight-bold link mr-2"
                 style="white-space: nowrap; height: 30px;"></a>
            </div>
          </div>
        </div>
        <div class="col-4 justify-content-end d-flex align-items-center">
            <span
              class="mr-2 font-weight-bold text-dark">{{ selectedAreas()?.size }} {{ 'lang.globals.areasSelected' | translate }}</span>
          <button (click)="deselectAreas()" [disabled]="selectedAreas()?.size < 1"
                  class="btn btn-danger btn-sm mr-1">{{ 'lang.globals.deselectAll' | translate }}
          </button>
          <button (click)="returnSelectedAreas()"
                  class="btn btn-primary btn-sm">{{ 'lang.globals.save' | translate }}
          </button>
        </div>
      </div>
    }
  </div>
</sb-table-wrapper-new>
